import Loading from "../../components/Loading";
import {useDispatch, useSelector} from "react-redux";
import {useEffect} from "react";
import {
    onOrderLoadDetails,
    onOrderRemovePendingByOrderId,
    onStaffOrdersLoad
} from '../../store/Orders/actions';
import ListDetails from "./components/ListDetails";
import ListOrders from "./components/ListOrders";

const   List = () => {
    const dispatch = useDispatch()

    const { orders, order, order_loading, loading, type, onlyFood } = useSelector(({ orders }) => orders)

    useEffect(() => {
        dispatch(onStaffOrdersLoad())
    }, [type])

    const onOrderClick = (orderId) => {
        dispatch(onOrderLoadDetails(orderId))
        dispatch(onOrderRemovePendingByOrderId(orderId))
    }

    return (
        <div className="mt-5">
            <div className="container flex mx-auto">
                <div className="container flex mx-auto">

                    <div className="w-1/3">
                        <Loading loading={loading}>
                            <ListOrders
                                orders={orders.data}
                                onOrderClick={onOrderClick}
                                order={order}
                                orderLoading={order_loading}/>
                        </Loading>
                    </div>

                    <div className="w-2/3 ml-2">
                        <Loading loading={order_loading}>
                            <ListDetails order={order} onlyFood={onlyFood} />
                        </Loading>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default List
